import 'css-chunk:src/components/accordion/accordion-component.module.scss';export default {
  "accordion": "accordion-component_accordion__hqkei",
  "header": "accordion-component_header__g8oNR",
  "heading": "accordion-component_heading__ISiVY",
  "title": "accordion-component_title__zIQEu",
  "subtitle": "accordion-component_subtitle__10tXx",
  "fixed": "accordion-component_fixed__NyVbF",
  "scrolled": "accordion-component_scrolled__sQ8Sm",
  "panel": "accordion-component_panel__g4-RG",
  "chevron": "accordion-component_chevron__sPTvw",
  "open": "accordion-component_open__lt10H",
  "disabled": "accordion-component_disabled__ua7am",
  "disable-toggle": "accordion-component_disable-toggle__kkE-Q"
};